import { render } from "./DotsPagination.vue?vue&type=template&id=f0b1c05c&scoped=true"
import script from "./DotsPagination.vue?vue&type=script&lang=js"
export * from "./DotsPagination.vue?vue&type=script&lang=js"

import "./DotsPagination.vue?vue&type=style&index=0&id=f0b1c05c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0b1c05c"]])

export default __exports__